export class Futtermittellieferant {
    futtermittellieferant_id: number;
    erstellt_von?: number;
    verbundene_kunden?: string;
    bezeichnung: string;
    email: string;
    telefon: string;
    mobil: string;
    fax: string;
    strasse: string;
    plz: string;
    ort: string;
    qs_id: string;
}
